<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app'
}
</script>
<script>
window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault()
  })
}
</script>
<style>
html, body {
  overflow-x: hidden;
  width: 100%;
  margin: 0;
  padding: 0;
  min-height: 100%;
}
#app {
  width: 100%;
  min-height: 100%;
}
</style>
